import axios from 'axios';
import { setApiUp } from './connectivity';
import { isDemoMode, demoRequest } from './demo';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

// В демо-режиме все запросы перехватываются локальным адаптером
// (services/demo.js) и не уходят на сервер.
const baseAdapterConfig = api.defaults.adapter;
api.defaults.adapter = (config) => {
  if (isDemoMode()) return demoRequest(config);
  if (typeof axios.getAdapter === 'function') return axios.getAdapter(baseAdapterConfig)(config);
  return Promise.reject(new Error('No HTTP adapter'));
};

export function getAccessToken() {
  return localStorage.getItem('token');
}

export function getRefreshToken() {
  return localStorage.getItem('refreshToken');
}

export function setTokens(token, refreshToken) {
  if (token) localStorage.setItem('token', token);
  else localStorage.removeItem('token');
  if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
  else localStorage.removeItem('refreshToken');
}

export function clearTokens() {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
}

let refreshPromise = null;

function tryRefresh() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return Promise.reject(new Error('Нет refresh-токена'));
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API_URL}/auth/refresh`, { refreshToken })
      .then((res) => {
        setTokens(res.data.token, res.data.refreshToken || refreshToken);
        return res.data.token;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

function isAuthEndpoint(url) {
  return /\/auth\/(login|register|refresh|forgot-password|reset-password|resend-confirmation)/.test(url || '');
}

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  } else {
    delete config.headers['Content-Type'];
  }
  return config;
});

api.interceptors.response.use(
  (res) => {
    setApiUp(true);
    return res;
  },
  async (err) => {
    if (!err.response) {
      setApiUp(false);
    }
    const status = err.response?.status;
    const url = err.config?.url || '';
    if ((status === 401 || status === 403) && !isAuthEndpoint(url)) {
      try {
        const token = await tryRefresh();
        const retryConfig = {
          ...err.config,
          headers: { ...err.config.headers, Authorization: `Bearer ${token}` },
        };
        return api.request(retryConfig);
      } catch (refreshErr) {
        clearTokens();
        const currentPath = window.location.pathname;
        if (currentPath !== '/login' && currentPath !== '/register') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export function absUrl(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;
  return `${window.location.origin}${url.startsWith('/') ? '' : '/'}${url}`;
}

export default api;
